import { createRouter, createWebHistory } from "vue-router";
import Layout from '@/layout/index.vue'
 
// 1. 配置路由
export const constantRoutes= [
  
  {
    path: "/login", // 默认路由 home页面
    component: () => import("@/views/login/index.vue")
  },
  {
		path: '/',
		component: Layout,
		redirect: 'index',
    img:'homepage.png',
		name: '首页',
    icon:'icon-shouye',
    parentId:0,
    id:1283,
		meta: {
			title: '首页',
			affix: true
		},
    children: [
      {
        path: '/index',
        name: '数据大屏',
        component: () => import('@/views/home/index.vue'),
        parentId:1283,
        id:1284,
        meta: {
          title: '数据大屏',
          affix: true
        }
      }
    ],
	},
  {
    path: '/user',
    name: '用户管理',
    component: Layout,
    img:"yonghu.png",
    icon:'icon-yonghu',
    parentId:0,
    id:1285,
    meta: {
      title: '用户管理'
    },
    children: [
      {
        path: '/user/userList',
        name: '用户列表',
        component: () => import('@/views/user/userList.vue'),
        meta: {
          title: '用户列表'
        },
        parentId:1285,
        id:1286,
      },
      {
        path: '/user/userCollect',
        name: '用户收藏',
        component: () => import('@/views/user/userCollect.vue'),
        meta: {
          title: '用户收藏'
        },
        hidden: true,
        parentId:1285,
        id:1287,
      },
      {
        path: '/user/userDetail',
        name: '用户详情',
        component: () => import('@/views/user/userDetail.vue'),
        meta: {
          title: '用户详情'
        },
        hidden: true,
        parentId:1285,
        id:1288,
      }
    ]
  },
  {
		path: '/companyManage',
		component: Layout,
		name: '企业管理',
    img:'qiye.png',
    icon:'icon-gongsi',
    parentId:0,
    id:1289,
		meta: {
			title: '企业管理'
		},
    children: [
      {
        path: '/companyManage',
        name: '企业管理',
        component: () => import('@/views/company/companyManageList.vue'),
        meta: {
          title: '企业管理'
        },
        parentId:1289,
        id:1290
      },
      {
        path: '/companyX',
        name: '草稿管理',
        component:null,
        meta: {
          title: '草稿管理'
        },
        parentId: 1289,
        id: 1291,
         children: [
                {
              path: '/companyDraft/draftAuditList',
              name: '资质认证',
              component: () => import('@/views/audit/draftAuditList.vue'),
              meta: {
                title: '资质认证'
              },
              parentId:1291,
              id:7303
            },
            {
              path: '/companyDraft/draftAuditDetail',
              name: '资质认证详情',
              component: () => import('@/views/audit/draftAuditDetail.vue'),
              meta: {
                title: '资质认证详情'
              },
              parentId:1291,
              id:7304,
              hidden: true
            },
            {
              path: '/companyDraft/draftSettleIn',
              name: '企业完善',
              component: () => import('@/views/audit/draftSettleIn.vue'),
              meta: {
                title: '企业完善'
              },
              parentId:1291,
              id:7308
            },
            {
              path: '/companyDraft/draftSettleInDetail',
              name: '企业完善详情',
              component: () => import('@/views/audit/draftSettleInDetail.vue'),
              meta: {
                title: '企业完善详情'
              },
              parentId:1291,
              id:7309,
              hidden: true
            },
        ]
      },
      {
        path: '/companyManage/employeeList',
        name: '员工列表',
        component: () => import('@/views/company/employeeList.vue'),
        meta: {
          title: '员工列表'
        },
        parentId:1289,
        id:1291,
        hidden: true
      },
      {
        path: '/companyManage/companyManageDetail',
        name: '企业详情',
        component: () => import('@/views/company/companyManageDetail.vue'),
        meta: {
          title: '企业详情'
        },
        parentId:1289,
        id:1292,
        hidden: true
    }
    ]
	},
  {
    path: '/shop',
    name: '店铺管理',
    icon:'icon-dianpu2',
    component: Layout,
    img:"shop.png",
    meta: {
      title: '店铺管理'
    },
    parentId:0,
    id:1293,
    children: [
      {
        path: '/shop/shopList',
        name: '店铺管理',
        component: () => import('@/views/shop/shopList.vue'),
        meta: {
          title: '店铺管理'
        },
        parentId:1293,
        id:1294
      },
      {
        path: '/shop/shopDetail',
        name: '店铺详情',
        component: () => import('@/views/shopDetail/shop.vue'),
        meta: {
          title: '店铺详情'
        },
        hidden: true,
        parentId:1293,
        id:1295
      },
      {
        path: '/shop/shopProductList',
        name: '店铺商品',
        component: () => import('@/views/shop/shopProductList.vue'),
        meta: {
          title: '店铺商品'
        },
        parentId:1293,
        id:1296,
        hidden: true
      }
    ]
  },
  {
    path: '/product',
    name: '产品管理',
    img:"product.png",
    component: Layout,
    icon:'icon-chanpinguanli',
    meta: {
      title: '产品管理'
    },
    parentId:0,
    id:1297,
    children: [
      {
        path: '/product/product',
        name: '产品管理',
        component: () => import('@/views/product/product.vue'),
        meta: {
          title: '产品管理'
        },
        parentId:1297,
        id:1298,
      },
      {
        path: '/product/selection',
        name: '甄选管理',
        component: () => import('@/views/product/selection.vue'),
        meta: {
          title: '甄选管理'
        },
        parentId:1297,
        id:2001,
      },
      {
        path: '/product/productType',
        name: '产品类型管理',
        component: () => import('@/views/product/productType.vue'),
        meta: {
          title: '产品类型管理'
        },
        parentId:1297,
        id:3298,
      },
      {
        path: '/product/productTypeAdd',
        name: '新增产品类型',
        component: () => import('@/views/product/productTypeAdd.vue'),
        meta: {
          title: '新增产品类型'
        },
        parentId:1297,
        id:2297,
        hidden: true,
      },
      {
        path: '/product/productTypeEdit',
        name: '编辑产品类型',
        component: () => import('@/views/product/productTypeEdit.vue'),
        meta: {
          title: '编辑产品类型'
        },
        parentId:1297,
        id:3296,
        hidden: true,
      },
      {
        path: '/product/productDetail',
        name: '产品详情',
        component: () => import('@/views/product/productDetail.vue'),
        meta: {
          title: '产品详情'
        },
        hidden: true,
        parentId:1297,
        id:1400
      }
    ]
  },
  {
    path: '/inquiry',
    name: '询单中心',
    component: Layout,
    parentId:0,
    img:"xundan.png",
    id:1299,
    meta: {
      title: '询单中心'
    },
    icon:'icon-yuyueshenqing',
    children: [
      {
        path: '/inquiry/offerList',
        name: '采购列表',
        component: () => import('@/views/inquiry/offerList.vue'),
        meta: {
          title: '采购列表'
        },
        parentId:1299,
        id:1300
      },
      {
        path: '/inquiry/findgoodsList',
        name: '找货集市',
        component: () => import('@/views/inquiry/findgoodsList.vue'),
        meta: {
          title: '找货集市'
        },
        parentId:1299,
        id:1900
      },
      {
        path: '/inquiry/purchaseList',
        name: '报价列表',
        component: () => import('@/views/inquiry/purchaseList.vue'),
        meta: {
          title: '报价列表'
        },
        parentId:1299,
        id:1301,
        hidden: true
      }
    ]
  },
  {
    path: '/requestorder',
    name: '订购与索样',
    img:"dingsuo.png",
    parentId:0,
    id:1306,
    icon:'icon-chuli',
    component: Layout,
    meta: {
      title: '订购与索样'
    },
    children: [
      {
        path: '/requestorder/order',
        name: '订购单管理',
        component: () => import('@/views/requestorder/order'),
        meta: {
          title: '订购单管理'
        },
        parentId:1306,
        id:1307,
      },
      {
        path: '/requestorder/requestSamples',
        name: '索样管理',
        component: () => import('@/views/requestorder/requestSamples'),
        meta: {
          title: '索样管理'
        },
        parentId:1306,
        id:1308,
      }
    ]
  },
  
  {
    path: '/content',
    name: '/content',
    component: Layout,
    icon:'icon-neirongguanli',
    parentId:0,
    img:"content.png",
    id:1309,
    meta: {
      title: '内容管理'
    },
    children: [
      {
        path: '/content/NewsInformation',
        name: '新闻资讯',
        component:null,
        meta: {
          title: '新闻资讯'
        },
        parentId:1309,
        id:9310,
        children:[
                  {
                    path: '/content/information/index',
                    name: '行业资讯',
                    component: () => import('@/views/content/information/index.vue'),
                    meta: {
                      title: '行业资讯'
                    },
                    parentId:9310,
                    id:1310
                  },
                  {
                    path: '/content/information/add',
                    name: '新建资讯',
                    component: () => import('@/views/content/information/add.vue'),
                    meta: {
                      title: '新建资讯'
                    },
                    hidden: true,
                    parentId:9310,
                    id:1311
                  },
                  {
                    path: '/content/information/edit',
                    name: '编辑资讯',
                    component: () => import('@/views/content/information/edit.vue'),
                    meta: {
                      title: '编辑资讯'
                    },
                    hidden: true,
                    parentId:9310,
                    id:1312
                },
                {
                    path: '/content/news/index',
                    name: '新闻动态',
                    component: () => import('@/views/content/news/index.vue'),
                    meta: {
                      title: '新闻动态'
                    },
                    parentId:9310,
                    id:2310
                  },
                  {
                    path: '/content/news/add',
                    name: '新建新闻',
                    component: () => import('@/views/content/news/add.vue'),
                    meta: {
                      title: '新建新闻'
                    },
                    hidden: true,
                    parentId:9310,
                    id:2311
                  },
                  {
                    path: '/content/news/edit',
                    name: '编辑新闻',
                    component: () => import('@/views/content/news/edit.vue'),
                    meta: {
                      title: '编辑新闻'
                    },
                    hidden: true,
                    parentId:9310,
                    id:2312
                },
        ]
      },
      {
        path: '/content/market/index',
        name: '价格行情',
        component: () => import('@/views/content/market/index.vue'),
        meta: {
          title: '价格行情'
        },
        parentId:1309,
        id:2008
      },
      {
        path: '/content/market/detail',
        name: '行情详情',
        component: () => import('@/views/content/market/detail.vue'),
        meta: {
          title: '行情详情'
        },
        parentId:1309,
        id:2009
      },
      {
        path: '/content/regulation/index',
        name: '法规政策',
        component: () => import('@/views/content/regulation/index.vue'),
        meta: {
          title: '法规政策'
        },
        parentId:1309,
        id:1313
      },
      {
        path: '/content/regulation/add',
        name: '新建法规',
        component: () => import('@/views/content/regulation/add.vue'),
        meta: {
          title: '新建法规'
        },
        hidden: true,
        parentId:1309,
        id:1314
      },
      {
        path: '/content/regulation/edit',
        name: '编辑法规',
        component: () => import('@/views/content/regulation/edit.vue'),
        meta: {
          title: '编辑法规'
        },
        hidden: true,
        parentId:1309,
        id:1315
      },
      {
        path: '/content/standard/index',
        name: '行业标准',
        component: () => import('@/views/content/standard/index.vue'),
        meta: {
          title: '行业标准'
        },
        parentId:1309,
        id:1316
      },
      {
        path: '/content/standard/add',
        name: '新建标准',
        component: () => import('@/views/content/standard/add.vue'),
        meta: {
          title: '新建标准'
        },
        hidden: true,
        parentId:1309,
        id:1317
      },
      {
        path: '/content/standard/edit',
        name: '编辑标准',
        component: () => import('@/views/content/standard/edit.vue'),
        meta: {
          title: '编辑标准'
        },
        hidden: true,
        parentId:1309,
        id:1318
      },
      {
        path: '/content/technology/index',
        name: '行业技术',
        component: () => import('@/views/content/technology/index.vue'),
        meta: {
          title: '行业技术'
        },
        parentId:1309,
        id:1319
      },
      {
        path: '/content/technology/add',
        name: '新建技术',
        component: () => import('@/views/content/technology/add.vue'),
        meta: {
          title: '新建技术'
        },
        hidden: true,
        parentId:1309,
        id:1320
      },
      {
        path: '/content/technology/edit',
        name: '编辑技术',
        component: () => import('@/views/content/technology/edit.vue'),
        meta: {
          title: '编辑技术'
        },
        hidden: true,
        parentId:1309,
        id:1321
      },
      {
        path: '/content/column/index',
        name: '行业专栏',
        component: () => import('@/views/content/column/index.vue'),
        meta: {
          title: '行业专栏'
        },
        parentId:1309,
        id:2319
      },
      {
        path: '/content/column/add',
        name: '新建专栏',
        component: () => import('@/views/content/column/add.vue'),
        meta: {
          title: '新建专栏'
        },
        hidden: true,
        parentId:1309,
        id:2320
      },
      {
        path: '/content/column/edit',
        name: '编辑专栏',
        component: () => import('@/views/content/column/edit.vue'),
        meta: {
          title: '编辑专栏'
        },
        hidden: true,
        parentId:1309,
        id:2321
      },
      {
        path: '/content/exhibition/index',
        name: '行业会展',
        component: () => import('@/views/content/exhibition/index.vue'),
        meta: {
          title: '行业会展'
        },
        parentId:1309,
        id:1322
      },
      {
        path: '/content/exhibition/add',
        name: '新建展会',
        component: () => import('@/views/content/exhibition/add.vue'),
        meta: {
          title: '新建展会'
        },
        hidden: true,
        parentId:1309,
        id:1323
      },
      {
        path: '/content/exhibition/edit',
        name: '编辑展会',
        component: () => import('@/views/content/exhibition/edit.vue'),
        meta: {
          title: '编辑展会'
        },
        hidden: true,
        parentId:1309,
        id:1324
      },
      {
        path: '/content/tagStatus',
        name: '标签、状态管理',
        component:null,
        meta: {
          title: '标签、状态管理'
        },
        parentId:1309,
        id:1325,
        children:[
          {
            path: '/content/tag/tag',
            name: '标签管理',
            component: () => import('@/views/content/tag/index.vue'),
            meta: {
              title: '标签管理'
            },
            parentId:1325,
            id:1326
          },
          {
            path: '/content/tag/add',
            name: '新建标签',
            component: () => import('@/views/content/tag/add.vue'),
            meta: {
              title: '新建标签'
            },
            hidden: true,
            parentId:1325,
            id:1327
          },
          {
            path: '/content/tag/edit',
            name: '编辑标签',
            component: () => import('@/views/content/tag/edit.vue'),
            meta: {
              title: '编辑标签'
            },
            hidden: true,
            parentId:1325,
            id:1328
          },
          {
            path: '/content/status/status',
            name: '状态管理',
            component: () => import('@/views/content/status/index.vue'),
            meta: {
              title: '状态管理'
            },
            parentId:1325,
            id:1329
          },
          {
            path: '/content/status/add',
            name: '新建状态',
            component: () => import('@/views/content/status/add.vue'),
            meta: {
              title: '新建状态'
            },
            hidden: true,
            parentId:1325,
            id:1330
          },
          
          {
            path: '/content/status/edit',
            name: '编辑状态',
            component: () => import('@/views/content/status/edit.vue'),
            meta: {
              title: '编辑状态'
            },
            hidden: true,
            parentId:1325,
            id:1331
          }
        ]
      }
    ]
  },
  {
    path: '/productLibrary',
    name: '产品库',
    img:"changpinku.png",
    component: Layout,
    icon:'icon-shangpin2',
    meta: {
      title: '产品库'
    },
    parentId:0,
    id:1347,
    children:[
      {
        path: '/productLibrary/productlibrarylist',
        name: '产品库管理',
        component: () => import('@/views/productLibrary/productlibrarylist/index.vue'),
        meta: {
          title: '产品库管理'
        },
        parentId:1347,
        id:1348
      },
      {
        path: '/productLibrary/add',
        name: '新增产品库',
        component: () => import('@/views/productLibrary/productlibrarylist/add.vue'),
        meta: {
          title: '新增产品库'
        },
        hidden: true,
        parentId:1347,
        id:1349
      },
      {
        path: '/productLibrary/edit',
        name: '编辑产品库',
        component: () => import('@/views/productLibrary/productlibrarylist/edit.vue'),
        meta: {
          title: '编辑产品库'
        },
        hidden: true,
        parentId:1347,
        id:1350 
      },
      {
        path: '/productLibrary/productlabel',
        name: '产品库标签',
        component: () => import('@/views/productLibrary/productlabel/index.vue'),
        meta: {
          title: '产品库标签'
        },
        parentId:1347,
        id:1351
      },
      {
        path: '/productLibrary/productliterature',
        name: '产品库标准',
        component: () => import('@/views/productLibrary/productliterature/index.vue'),
        meta: {
          title: '产品库标准'
        },
        parentId:1347,
        id:1352
      }
    ]
  },
  {
    img:"qiyeku.png",
    path: '/enterpriseLibrary',
    name: '企业库',
    parentId:0,
    id:1353,
    component: Layout,
    icon:'icon-shopping-bag-fill',
    meta: {
      title: '企业库'
    },
    children:[
      {
        path: '/enterpriseLibrary/enterpriselibrarylist',
        name: '企业库管理',
        component: () => import('@/views/enterpriseLibrary/enterpriselibrarylist/index.vue'),
        meta: {
          title: '企业库管理'
        },
        parentId:1353,
        id:1354
      },
      {
        path: '/enterpriseLibrary/enterpriselibrarytype',
        name: '企业库类型',
        component: () => import('@/views/enterpriseLibrary/enterpriselibrarytype/index.vue'),
        meta: {
          title: '企业库类型'
        },
        parentId:1353,
        id:1355
      },
      {
        path: '/enterpriseLibrary/add',
        name: '新增企业库',
        component: () => import('@/views/enterpriseLibrary/enterpriselibrarylist/add.vue'),
        meta: {
          title: '新增企业库'
        },
        hidden: true,
        parentId:1353,
        id:1356 
      },
      {
        path: '/enterpriseLibrary/edit',
        name: '编辑企业库',
        component: () => import('@/views/enterpriseLibrary/enterpriselibrarylist/edit.vue'),
        meta: {
          title: '编辑企业库'
        },
        hidden: true,
        parentId:1353,
        id:1357  
      }
    ]
  },
  {
    path: '/onlineLaboratory',
    name: '线上实验室',
    img:"shenhe.png",
    component: Layout,
    icon:'icon-shenhe',
    parentId:0,
    id:1500,
    meta: {
      title: '线上实验室'
    },
    children: [
      {
        path: '/onlineLaboratory/formula',
        name: '配方管理',
        component: () => import('@/views/onlineLaboratory/formulamanage'),
        meta: {
          title: '配方管理'
        },
        parentId:1500,
        id:1501
      },
      {
        path: '/onlineLaboratory/draft',
        name: '配方草稿',
        component: () => import('@/views/onlineLaboratory/formuladraft'),
        meta: {
          title: '配方草稿'
        },
        parentId:1500,
        id:1502
      },
      {
        path: '/onlineLaboratory/standardcontent',
        name: '营养素含量国标',
        component: () => import('@/views/onlineLaboratory/standardcontent'),
        meta: {
          title: '营养素含量国标'
        },
        parentId:1500,
        id:1503
      },
      {
        path: '/onlineLaboratory/materialstory',
        name: '营养素原料库',
        component: () => import('@/views/onlineLaboratory/materialstory'),
        meta: {
          title: '营养素原料库'
        },
        parentId:1500,
        id:1504
      }
    ]
  },
  {
    path: '/audit',
    name: '审核管理',
    img:"shenhe.png",
    component: Layout,
    icon:'icon-shenhe',
    parentId:0,
    id:1302,
    meta: {
      title: '审核管理'
    },
    children: [
      {
        path: '/audit/companyAuditList',
        name: '企业审核',
        component: () => import('@/views/audit/companyAuditList'),
        meta: {
          title: '企业审核'
        },
        parentId:1302,
        id:1303
      },
      {
        path: '/audit/companyAuditDetail',
        name: '审核详情',
        component: () => import('@/views/audit/companyAuditDetail'),
        meta: {
          title: '审核详情'
        },
        hidden: true,
        parentId:1302,
        id:1304
      },
       
      {
        path: '/audit/claimReviewList',
        name: '认领审核',
        component: () => import('@/views/audit/claimReviewList'),
        meta: {
          title: '认领审核'
        },
        parentId:1302,
        id:1456
      },
      {
        path: '/audit/claimReviewDetail',
        name: '认领详情',
        component: () => import('@/views/audit/claimReviewDetail'),
        meta: {
          title: '认领详情'
        },
        hidden: true,
        parentId:1302,
        id:1305
      }
    ]
  },
  {
    path: '/draw',
    img:"changpinku.png",
    name: '抽奖管理',
    icon:'icon-shangpin2',
    component: Layout,
    parentId:0,
    id:3342,
    meta: {
      title: '抽奖管理'
    },
    children: [
      {
        path: '/draw/drawActivity',
        name: '抽奖活动',
        component: () => import('@/views/draw/drawActivity/index.vue'),
        meta: {
          title: '抽奖活动'
        },
        parentId:3342,
        id:3343
      },
      {
        path: '/draw/drawLog',
        name: '抽奖日志',
        component: () => import('@/views/draw/drawLog/index.vue'),
        meta: {
          title: '抽奖日志'
        },
        parentId:3342,
        id:3345
      },
      {
        path: '/draw/prizesManage',
        name: '奖品管理',
        component: () => import('@/views/draw/prizesManage/index.vue'),
        meta: {
          title: '奖品管理'
        },
        parentId:3342,
        id:3346
      }
    ]
  },
  {
    path: '/message',
    img:"message.png",
    name: '消息管理',
    icon:'icon-duanxinguanli',
    component: Layout,
    parentId:0,
    id:1342,
    meta: {
      title: '消息管理'
    },
    children: [
      {
        path: '/message/onlineservice',
        name: '在线客服',
        component: () => import('@/views/message/onlineservice/index.vue'),
        meta: {
          title: '在线客服'
        },
        parentId:1342,
        id:1343
      },
      {
        path: '/message/chat',
        name: '在线聊天',
        component: () => import('@/views/message/onlineservice/chat.vue'),
        meta: {
          title: '在线聊天'
        },
        parentId:1342,
        id:3001
      },
      {
        path: '/message/leavemessage',
        name: '在线留言',
        component: () => import('@/views/message/leavemessage/index.vue'),
        meta: {
          title: '在线留言'
        },
        parentId:1342,
        id:2002
      },
      {
        path: '/message/notice',
        name: '公告消息',
        component: () => import('@/views/message/notice/index.vue'),
        meta: {
          title: '公告消息'
        },
        parentId:1342,
        id:1344
      },
      {
        path: '/message/notice/add',
        name: '新增公告',
        component: () => import('@/views/message/notice/add.vue'),
        meta: {
          title: '新增公告'
        },
        hidden: true,
        parentId:1342,
        id:1345
      },
      {
        path: '/message/notice/edit',
        name: '编辑公告',
        component: () => import('@/views/message/notice/edit.vue'),
        meta: {
          title: '编辑公告'
        },
        hidden: true,
        parentId:1342,
        id:1346
      }
    ]
  },
  {
    path: '/base',
    img:"base.png",
    name: '基础管理',
    parentId:0,
    id:1332,
    component: Layout,
    icon:'icon-gjichus',
    meta: {
      title: '基础管理'
    },
    children: [
      {
        path: '/base/banner',
        name: '广告位管理',
        component: () => import('@/views/base/banner/index.vue'),
        meta: {
          title: '广告位管理'
        },
        parentId:1332,
        id:1333
      },
      {
        path: '/base/banner/add',
        name: '新增广告位',
        component: () => import('@/views/base/banner/add.vue'),
        meta: {
          title: '新增广告位'
        },
        hidden: true,
        parentId:1332,
        id:1334
      },
      {
        path: '/base/banner/edit',
        name: '编辑广告位',
        component: () => import('@/views/base/banner/edit.vue'),
        meta: {
          title: '编辑广告位'
        },
        hidden: true,
        parentId:1332,
        id:1335
      },
      {
        path: '/base/aboutus',
        name: '关于我们',
        component: () => import('@/views/base/aboutus/index.vue'),
        meta: {
          title: '关于我们'
        },
        parentId:1332,
        id:1336
      },
      {
        path: '/base/aboutus/edit',
        name: '编辑关于我们',
        component: () => import('@/views/base/aboutus/edit.vue'),
        meta: {
          title: '编辑关于我们'
        },
        hidden: true,
        parentId:1332,
        id:1337
      },
      {
        path: '/base/specialstatement',
        name: '特别声明',
        component: () => import('@/views/base/specialstatement/index.vue'),
        meta: {
          title: '特别声明'
        },
        parentId:1332,
        id:1338
      },
      {
        path: '/base/specialstatement/edit',
        name: '编辑特别声明',
        component: () => import('@/views/base/specialstatement/edit.vue'),
        meta: {
          title: '编辑特别声明'
        },
        hidden: true,
        parentId:1332,
        id:1339
      },
      {
        path: '/base/feedback',
        name: '意见反馈',
        component: () => import('@/views/base/feedback/index.vue'),
        meta: {
          title: '意见反馈'
        },
        parentId:1332,
        id:1340
      },
      {
        path: '/base/helpcenter',
        name: '帮助中心',
        component: () => import('@/views/base/helpcenter/index.vue'),
        meta: {
          title: '帮助中心'
        },
        parentId:1332,
        id:1341
      }
    ]
  },
  {
    img:"set.png",
    path: '/system',
    name: '系统管理',
    parentId:0,
    id:1358,
    component: Layout,
    icon:'icon-shezhi',
    meta: {
      title: '系统管理'
    },
    children: [
      {
        path: '/system/employee',
        name: '员工管理',
        component: () => import('@/views/system/employee/index.vue'),
        meta: {
          title: '员工管理'
        },
        parentId:1358,
        id:1359
      },
      {
        path: '/system/employee/add',
        name: '新增员工',
        component: () => import('@/views/system/employee/add.vue'),
        meta: {
          title: '新增员工'
        },
        hidden: true,
        parentId:1358,
        id:1360  
      },
      {
        path: '/system/employee/edit',
        name: '编辑员工',
        component: () => import('@/views/system/employee/edit.vue'),
        meta: {
          title: '编辑员工'
        },
        hidden: true,
        parentId:1358,
        id:1361  
      },
      {
        path: '/system/role',
        name: '角色管理',
        component: () => import('@/views/system/role/index.vue'),
        meta: {
          title: '角色管理'
        },
        parentId:1358,
        id:1362
      },
      {
        path: '/system/role/add',
        name: '新建角色',
        component: () => import('@/views/system/role/add.vue'),
        meta: {
          title: '新建角色'
        },
        hidden: true,
        parentId:1358,
        id:1363
      },
      {
        path: '/system/role/edit',
        name: '编辑角色',
        component: () => import('@/views/system/role/edit.vue'),
        meta: {
          title: '编辑角色'
        },
        hidden: true,
        parentId:1358,
        id:1364
      },
      {
        path: '/system/log',
        name: '日志管理',
        parentId:1358,
        id:1365,
        component:null,
        meta: {
          title: '日志管理'
        },
        children:[
          {
            path: '/system/log/control',
            name: '日志管理',
            component: () => import('@/views/system/log/control/index.vue'),
            meta: {
              title: '操作日志'
            },
            parentId:1365,
            id:1366,
          },
          {
            path: '/system/log/login',
            name: '登录日志',
            component: () => import('@/views/system/log/login/index.vue'),
            meta: {
              title: '登录日志'
            },
            parentId:1365,
            id:1367,
          },
          {
            path: '/system/log/message',
            name: '短信日志',
            component: () => import('@/views/system/log/message/index.vue'),
            meta: {
              title: '短信日志'
            },
            parentId:1365,
            id:1368,
          }
        ]
      },
      {
        path: '/system/log/control',
        name: '短信管理',
        component:null,
        meta: {
          title: '短信管理'
        },
        parentId:1358,
        id:1369,
        children:[
          {
            path: '/system/message/template',
            name: '短信模版',
            component: () => import('@/views/system/message/template/index.vue'),
            meta: {
              title: '短信模版'
            },
            parentId:1369,
            id:1370
          },
          {
            path: '/system/message/template/add',
            name: '新增模版',
            component: () => import('@/views/system/message/template/add.vue'),
            meta: {
              title: '新增模版'
            },
            parentId:1369,
            id:1371,
            hidden: true 
          },
          {
            path: '/system/message/template/edit',
            name: '编辑模版',
            component: () => import('@/views/system/message/template/edit.vue'),
            meta: {
              title: '编辑模版'
            },
            parentId:1369,
            id:1372,
            hidden: true 
          },
          {
            path: '/system/message/channel',
            name: '短信渠道',
            component: () => import('@/views/system/message/channel/index.vue'),
            meta: {
              title: '短信渠道'
            },
            parentId:1369,
            id:1373
          },
          {
            path: '/system/message/channel/add',
            name: '新增渠道',
            component: () => import('@/views/system/message/channel/add.vue'),
            meta: {
              title: '新增渠道'
            },
            parentId:1369,
            id:1374,
            hidden: true 
          },
          {
            path: '/system/message/channel/edit',
            name: '编辑渠道',
            component: () => import('@/views/system/message/channel/edit.vue'),
            meta: {
              title: '编辑渠道'
            },
            hidden: true ,
            parentId:1369,
            id:1375 
          }
        ]
      }
    ]
  }
];
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL), 
  routes:constantRoutes,
});
 
export default router

